import { render, staticRenderFns } from "./PerformanceCommonUpload.vue?vue&type=template&id=8a4b5856&"
import script from "./PerformanceCommonUpload.vue?vue&type=script&lang=js&"
export * from "./PerformanceCommonUpload.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCommonUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports